import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CELL_SETS_DELETE } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var deleteCellSetJsonMerger = function deleteCellSetJsonMerger(cellSetKey, cellClasskey) {
  return [{
    $match: {
      query: "$[?(@.key == \"".concat(cellClasskey, "\")]"),
      value: {
        children: [{
          $match: {
            query: "$[?(@.key == \"".concat(cellSetKey, "\")]"),
            value: {
              $remove: true
            }
          }
        }]
      }
    }
  }];
};
var deleteCellSet = function deleteCellSet(experimentId, key, cellClassKey) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error;
            if (!(loading || error)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", null);
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"), {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/boschni-json-merger+json'
              },
              body: JSON.stringify(deleteCellSetJsonMerger(key, cellClassKey))
            });
          case 6:
            _context.next = 8;
            return dispatch({
              type: CELL_SETS_DELETE,
              payload: {
                key: key
              }
            });
          case 8:
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteCellSet;